export interface InfoBoxProps {
    title: string,
    body: string | number | undefined
}

export const InfoBox = (props: InfoBoxProps) => {
    return (
        <div style={{
            width: "200px",
            padding: 0,
            backgroundColor: "#3296b8",
            color: "white",
            borderRadius: "0.375rem",
            border: "1px solid #c4d1df",
            marginLeft: 10
        }}>
            <div style={{ textAlign: "center", borderBottom: "1px solid", padding: 12 }}>
                <b>{props.title}</b>
            </div>
            <div style={{ textAlign: "center", fontSize: "24px", padding: 18 }}>
                <b>{props.body}</b>
            </div>
        </div>
    );
};
